(() => {
  let refreshPending = false;
  const watchBoundaries = (element) => {
    const now = Date.now();
    const boundary = [element.dataset.start, element.dataset.end]
      .map((value) => Date.parse(value))
      .filter((value) => Number.isFinite(value) && value > now)
      .sort((a, b) => a - b)[0];
    if (!boundary) return () => {};
    let timer;
    const check = () => {
      clearTimeout(timer);
      if (Date.now() >= boundary) {
        if (!refreshPending) {
          refreshPending = true;
          const destination = new URL(location.href);
          destination.searchParams.set('_neills_offer_at', String(boundary));
          location.replace(destination.href);
        }
      } else {
        timer = setTimeout(check, Math.min(boundary - Date.now() + 1500, 2147483647));
      }
    };
    const onVisibility = () => {
      if (!document.hidden) check();
    };
    document.addEventListener('visibilitychange', onVisibility);
    check();
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  };

  if (!customElements.get('neills-offer-boundary')) {
    customElements.define('neills-offer-boundary', class extends HTMLElement {
      connectedCallback() {
        if (this.stopBoundaryWatch) return;
        this.stopBoundaryWatch = watchBoundaries(this);
      }
      disconnectedCallback() {
        this.stopBoundaryWatch?.();
        this.stopBoundaryWatch = null;
      }
    });
  }

  if (!customElements.get('neills-offer-switcher')) {
    customElements.define('neills-offer-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.scope = this.closest('.js-product');
        this.onVariant = (event) => this.update(event.detail?.variant?.id);
        this.scope?.addEventListener('on:variant:change', this.onVariant);
        this.update(this.dataset.variant);
        this.stopBoundaryWatch = watchBoundaries(this);
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('on:variant:change', this.onVariant);
        this.stopBoundaryWatch?.();
        this.ready = false;
      }
      update(id) {
        let active = false;
        this.querySelectorAll('[data-offer-variant]').forEach((panel) => {
          const selected = String(id) === panel.dataset.offerVariant;
          panel.hidden = !selected;
          if (selected && Number(panel.dataset.offerPrice) > 0) active = true;
        });
        const native = this.scope?.querySelector('[data-neills-native-price]');
        if (native) native.hidden = active;
        this.scope?.querySelectorAll('[data-neills-catalog-financing]').forEach((el) => el.hidden = active);
        this.scope?.querySelectorAll('[data-neills-offer-financing]').forEach((el) => el.hidden = !active);
        this.scope?.querySelectorAll('[data-neills-project-note]').forEach((el) => el.hidden = !active);
      }
    });
  }
})();
